app.controller(
    'PlaceCorrectionController', ['$scope', '$rootScope', '$http', '$stateParams', '$state', '$timeout', 'toastr', '$document', 'Configuration', 'PlaceService', 'SideBarService', '$sce', '$translate', 'HelperService', PlaceCorrectionController]
);

function PlaceCorrectionController($scope, $rootScope, $http, $stateParams, $state, $timeout, toastr, $document, Configuration, PlaceService, SideBarService, $sce, $translate , HelperService ) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);

    $scope.vm = {};
    $scope.edit = {};

    $scope.vm.ActiveDescription = {};
    $scope.vm.ActiveDescriptionId = 0;
    $scope.vm.ActiveDescriptionVm =
      {
          Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
          QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
          DescriptionNewPositionText: '1'
      };
    $scope.vm.ActiveDescriptionVmOrigin = angular.copy($scope.vm.ActiveDescriptionVm);

    $scope.vm.StatusList4WorkflowDescription = ['', '', '', '', '', ''];
    //Get Single 
    var promiseGetSingle = PlaceService.getPlace($stateParams.id, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    promiseGetSingle.then(function (t) {
        var res = t.data;
        $scope.vm = res;
        $scope.vmOrigin = angular.copy($scope.vm);
        $rootScope.PlaceList = res.PlaceList;
        $rootScope.CurrentObjectId = res.CurrentPlace.PlaceId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Place;
         $rootScope.SideBar = res.SideBar;
        $rootScope.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.Comments = res.CommentList;
       
        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList;
        $scope.ChangeZoneById($scope.vm.ParamZoneId);


        if ($scope.vm.DescriptionList.length > 0) {
            $scope.vm.ActiveDescriptionId = 0;
            $scope.vm.ActiveDescription = $scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId];
            $scope.GetDescriptionVm();
        }
        $scope.vm.StatusList4WorkflowDescription = angular.copy($rootScope.StatusList4WorkflowDescription);

    });

    $scope.UpdateDescription = function UpdateDescription() {
        if ($scope.vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescription($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId])
                .then(function (data) {


                });
        }
    }
    $scope.GetDescriptionVm = function GetDescriptionVm() {
        HelperService.GetDescriptionVmWithSort($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId].DescriptionId, $stateParams.id, 12, 0, $scope.CurrentLang)
            .then(function (desc) {
                $scope.vm.ActiveDescriptionVm = desc;
                $scope.vm.ActiveDescriptionVmOrigin = angular.copy($scope.vm.ActiveDescriptionVm);
            });
    }
    $scope.PreviousDesc = function PreviousDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId > 0) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId - 1;
            GetDescriptionVm();
        }
    }

    $scope.NextDesc = function NextDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId < $scope.vm.DescriptionList.length - 1) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId + 1;
            GetDescriptionVm();
        }
    }
    $scope.UpdateDescriptionStatus = function UpdateDescriptionStatus() {
        if ($scope.vm.ActiveDescriptionVm.Description != undefined) {
            //console.log("test: " +vm.ActiveDescriptionVm.Description.DescriptionId + " : " + $scope.CurrentLang + " : " +vm.ActiveDescriptionVm.DescriptionStatus);
            HelperService.UpdateDescriptionStatus($scope.vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, $scope.vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    $scope.UpdateDescriptionPosition = function UpdateDescriptionPosition() {
        if ($scope.vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionPosition($stateParams.id, $scope.vm.ActiveDescriptionVm.Description.DescriptionId, $scope.vm.ActiveDescriptionVm.DescriptionCurrentPositionText, $scope.vm.ActiveDescriptionVm.DescriptionNewPositionText, 12);
        }
    }
    $scope.AddDescriptionToClient = function AddDescriptionToClient() {
        HelperService.AddDescriptionToClient($scope.vm.ActiveDescriptionVm.Clients, $scope.vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    $scope.AddQualificationToDescription = function AddQualificationToDescription() {
        HelperService.AddQualificationToDescription($scope.vm.ActiveDescriptionVm.QualificationList, $scope.vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    $scope.OpenInOtherLang = function (lang) {
        $state.go('app.correction.place', { id: $stateParams.id, lang: lang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: $scope.vm.DescriptionList.length });        
    }

    $scope.UpdatePlace = function UpdatePlace() {

        PlaceService.UpdatePlace($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;

            } else {
                console.log("error: ");
            }
        });
    };

    //$scope.UpdateDescription = function UpdateDescription() {

    //    PlaceService.UpdateDescription($scope.vm, function (response) {

    //        if (response.success) {

    //            console.log("ok: ");
    //            $scope.vm = response;
    //        } else {
    //            console.log("error: ");
    //        }
    //    });
    //};

    //$scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {
    //    $scope.vm.DescriptionList[index].Description.StatusId = status;
    //    PlaceService.UpdateDescriptionStatus($scope.vm, function (response) {

    //        if (response.success) {

    //            console.log("ok: ");
    //            $scope.vm = response;
    //        } else {
    //            console.log("error: ");
    //        }
    //    });
    //};


    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {

        SideBarService.UpdateObjectStatus(status, objectId, $stateParams.lang, 12, function (response) {

            if (response.success) {

                console.log("ok: ");

            } else {
                console.log("error: ");
            }
        });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($scope.vm.SideBar.CommentEdit, $scope.vm.CurrentPlace.PlaceId, $scope.CurrentLang, 12);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        SideBarService.SaveDiffuseur($scope.vm.ClientList, $scope.vm.CurrentPlace.PlaceId, $scope.CurrentLang, 12);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        SideBarService.SaveAdressesAssociees($scope.vm.PlaceList, $scope.vm.CurrentPlace.PlaceId, $scope.CurrentLang, 12);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        SideBarService.SaveClassification($scope.vm.ClassificationList, $scope.vm.CurrentPlace.PlaceId, $scope.CurrentLang, 12);
    };

    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Place", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      console.log("testtest2");
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);
                      
                  },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailSharePlacePracticalInfo', $translate.instant('emailSharePlacePracticalInfo').replaceAll('&amp;', '&'), $rootScope.placevm);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
};